<div class="tt-component-widget_container" [attr.unique-id]="component().uniqueId">
  <div class="tt-component-widget">
    <div class="tt-component-widget_header" (click)="toggleExpanded()">
      <div class="tt-component-widget_header-expand">
        <mat-icon
          class="tt-component-widget_header-expand-icon"
          [class.tt-component-widget_header-expand-icon--expanded]="expanded()"
          [icon]="hasContent() ? 'chevron-down' : 'dot'"
          [iconSize]="16" />
      </div>

      <div class="tt-component-widget_header-left">
        <div
          class="tt-component-widget_header-title"
          ttCommentableElement
          [elementId]="`${component().uniqueId}-title`"
          [widgetId]="widget().uniqueId">
          {{ title() }}
        </div>

        <tt-resource-tag-list [readonly]="true" [tags]="widget().resourceTags ?? []" />

        <tt-attachments-links-references-tag
          [attachments]="attachments()"
          [isEditImportedMode]="guidelineViewService.isEditImportedGuidelineMode()"
          [isPreviewMode]="guidelineViewService.isPreviewMode()"
          [isUpdateReviewMode]="guidelineViewService.isPublishReviewMode()"
          [links]="widget().links"
          [medicationRequests]="medicationRequests()"
          [optional]="optional()"
          [references]="widget().references" />
      </div>
      <span class="tt-component-widget_header-divider"></span>

      @if (tag()) {
        <tt-guideline-update-tag
          class="tt-smartbook-chapter_original-tag"
          [readonly]="!allowEditTags()"
          [tag]="tag()"
          (tagUpdated)="handleTagUpdated($event)" />
      }
    </div>

    @if (expanded() && hasDescription()) {
      <div class="tt-component-widget_content">
        <tt-text-widget [widget]="descriptionWidget()" />
      </div>
    }
  </div>

  @if (childrenWidgets().length > 0 && expanded()) {
    <div class="tt-component-widget_children">
      @for (child of childrenWidgets(); track child.uniqueId) {
        <tt-component-widget [allowEditTags]="allowEditTags()" [expandStrategy]="expandStrategy()" [widget]="child" />
      }
    </div>
  }
</div>
